import Button from "core/buttons/button/Button";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "api/user/msalConfig";
import { useUserContext } from "api/user/UserProvider";

const LoginAlternatives = ({ onRequestNormal, showNormalButton }) => {
  const { instance, inProgress } = useMsal();
  const { setShowLoginFallbackHint } = useUserContext();
  const ssoReady = inProgress === InteractionStatus.None;

  const handleSsoLogin = () => {
    if (!ssoReady) return;
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error("MSAL loginRedirect", e);
      setShowLoginFallbackHint(true);
    });
  };

  return (
    <div className="login-alternatives-stack">
      <div className="center-button">
        <Button
          className="btn-hover-color"
          size="medium-standard"
          color="blue"
          id="login_sso"
          onClick={handleSsoLogin}
          disabled={!ssoReady}
        >
          <FormattedMessage id={"login_sso"} defaultMessage={"Se connecter"} />
        </Button>
      </div>
      {showNormalButton && (
        <div className="center-button">
          <Button
            className="btn-hover-color"
            size="medium-standard"
            color="blue"
            id="login_normal"
            onClick={onRequestNormal}
          >
            <FormattedMessage id={"login_normal"} defaultMessage={"Normal"} />
          </Button>
        </div>
      )}
      <div className="login-fallback-hint">
        <a
          href="#"
          id="login_fallback_link"
          onClick={(e) => {
            e.preventDefault();
            onRequestNormal();
          }}
        >
          <FormattedMessage
            id={"login_from_ca_es"}
            defaultMessage={"From CA or ES? Click here"}
          />
        </a>
      </div>
    </div>
  );
};

LoginAlternatives.propTypes = {
  onRequestNormal: PropTypes.func.isRequired,
  showNormalButton: PropTypes.bool,
};

export default LoginAlternatives;
